import { createStyles, makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material";

export const LanguageMenuStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: "5rem",
      color: theme.palette.background.default
    },
    components: {
      MuiButton: {
        raisedPrimary: {
          color: "white"
        }
      },
    },
  })
);
